/**
 * The one path shape the batch and benchmark APIs accept from a customer:
 * s3://bucket or s3://bucket/prefix. Bucket names are lowercase DNS-ish.
 */
export const S3_PATH_PATTERN = /^s3:\/\/[a-z0-9][a-z0-9.-]+[a-z0-9](\/.*)?$/

export function isS3Path(value: string): boolean {
  return S3_PATH_PATTERN.test(value.trim())
}
